import type { PlateMeta } from '../worker/protocol';
import { plateOptions } from '../lib/film-view';

/**
 * The viewer HUD's screen-print control: which plate (or the composite proof)
 * the canvas shows, and whether to look at that plate's film at 1:1. Replaces
 * the DTF Output/Source buttons in the same row while a built separation is on
 * screen; the background buttons and the readout beside it are unchanged.
 *
 * Film view needs a plate to render a film FROM, so it is disabled — rather
 * than hidden — on the proof: hiding it would move the row's contents every
 * time the select changed.
 */
export function PlateBar({ plates, plate, filmView, onPlate, onFilmView }: {
  plates: PlateMeta[];
  plate: string;
  filmView: boolean;
  onPlate(next: string): void;
  onFilmView(next: boolean): void;
}) {
  const noPlate = plate === 'proof';
  return (
    <>
      <select aria-label="Plate" value={plate} onChange={(e) => onPlate(e.target.value)}>
        {plateOptions(plates).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <button
        className={filmView ? 'primary' : ''}
        aria-pressed={filmView}
        disabled={noPlate}
        title={noPlate ? 'Film view needs a plate' : 'Show this plate’s film at 1:1'}
        onClick={() => onFilmView(!filmView)}
      >
        Film 1:1
      </button>
    </>
  );
}
